import React, { useState, useEffect } from 'react';
import { getBuyerPageData } from '../services/buyerService';
import { getStrapiMedia, renderSafeText } from '../lib/strapi';
import { ShoppingCart, ShieldCheck, Zap, BarChart3 } from 'lucide-react';

const Buyers = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      const result = await getBuyerPageData();
      setData(result);
      setLoading(false);
    };
    fetchData();
  }, []);

  if (loading || !data) {
    return (
      <div className="py-40 text-center flex flex-col items-center justify-center space-y-4">
        <div className="w-12 h-12 border-4 border-widya-green border-t-transparent rounded-full animate-spin"></div>
        <p className="text-gray-400 font-bold uppercase tracking-widest text-[10px]">Loading Buyer Portal...</p>
      </div>
    );
  }

  const heroImageUrl = getStrapiMedia(data.hero_image);
  const marketplaceImages = Array.isArray(data.marketplace_image)
    ? data.marketplace_image
    : data.marketplace_image ? [data.marketplace_image] : [];

  return (
    <div className="bg-white">
      <section className="relative overflow-hidden min-h-[60vh] lg:min-h-[85vh] flex items-center justify-center">
        {heroImageUrl ? (
          <>
            <div
              className="absolute inset-0 bg-cover bg-center bg-no-repeat"
              style={{ backgroundImage: `url(${heroImageUrl})` }}
            />
            <div className="absolute inset-0 bg-black/40" />
          </>
        ) : (
          <div className="absolute inset-0 bg-widya-footer" />
        )}

        <div className="container mx-auto px-6 text-center relative z-10 w-full max-w-[1200px]">
          <h1 className="text-[46px] md:text-[64px] lg:text-[80px] font-bold tracking-tight leading-[1.1] max-w-5xl mx-auto font-heading text-white drop-shadow-lg">
            {renderSafeText(data.hero_title)}
          </h1>
          {data.hero_subtitle && (
            <p className="text-xl text-white/90 max-w-2xl mx-auto font-light leading-relaxed mt-6">
              {renderSafeText(data.hero_subtitle)}
            </p>
          )}
        </div>
      </section>

      <section className="py-32 px-6 bg-white overflow-hidden">
        <div className="container mx-auto max-w-[1100px]">
          
          <h2 className="text-[40px] font-bold leading-[48px] tracking-[-1px] text-black font-heading mb-[40px] text-center max-w-4xl mx-auto">
            {renderSafeText(data.description_heading)}
          </h2>

          <div className="grid lg:grid-cols-2 gap-x-12 gap-y-16 items-start">
            
            <div className="flex flex-col gap-16">
              <ul className="list-disc pl-5 space-y-4 text-[#333333] text-[18px] font-normal leading-[23px] tracking-[-0.5px] marker:text-[#333333] pr-8 mt-[24px]">
                {data.feature_highlights?.map((item, i) => (
                  <li key={i}>{renderSafeText(item.feature_description)}</li>
                ))}
              </ul>
              
              {marketplaceImages.length > 1 && getStrapiMedia(marketplaceImages[1]) && (
                <img
                  src={getStrapiMedia(marketplaceImages[1])}
                  alt="Harvest Flow Process"
                  className="w-full h-auto object-contain"
                />
              )}
            </div>

            <div className="flex flex-col items-center lg:items-end">
              {marketplaceImages.length > 0 && getStrapiMedia(marketplaceImages[0]) && (
                <img
                  src={getStrapiMedia(marketplaceImages[0])}
                  alt="Marketplace interface"
                  className="w-full h-auto object-contain"
                />
              )}
            </div>

          </div>
        </div>
      </section>

    </div>
  );
};

export default Buyers;